<template>
	
	<v-dialog
		class="loader"
		v-model="active"
		:width="width"
		:height="height"
		persistent
		:overlay-opacity="overlayOpacity">
		
		<v-card
			class="pt-6 pb-4">
        	<v-card-text
			  	class="">
                {{ message }}
                <v-progress-linear
                    indeterminate
                    :color="progressBarColor"
                    class="mt-2">
                </v-progress-linear>
            </v-card-text>
   	    </v-card>

	</v-dialog>

</template>

<style>
	.loader {
		z-index: 1000;
	}
</style>

<script>
import { EventBus } from '@/components/EventBus.js';
const { Utils } = require('@/assets/js/scripts/utils/Utils.js');

export default {
	name: 'loader',
	props: [
		
	],

	created() {
		EventBus.$on('open_loader', () => {
			this.open();
		});

		EventBus.$on('close_loader', () => {
			this.close();
		});
	},

	data: () => ({
		active: false,
		width: 300,
		height: 200,
		message: "Attendere. Operazione in corso...",
		progressBarColor: "blue",

		overlayOpacity: 0.5,

		openEventCount: 0,
		closeEventCount: 0
	}),

	methods: {
		setDialog(dialog) {
			if(typeof dialog === "undefined") {
				return;
			}

			// Imposta il messaggio
			if(dialog.message) {
				this.message = dialog.message;
			}

			// Imposta eventuale opacità di overflow
			if(!Utils.isNullOrUndefined(dialog.overlayOpacity) && parseFloat(dialog.overlayOpacity) != "NaN") {
				this.overlayOpacity = parseFloat(dialog.overlayOpacity);
			}
		},

		resetEventsCount: function() {
			this.openEventCount = 0;
			this.closeEventCount = 0;
		},

		open: function(dialog) {
			this.openEventCount++;
			this.setDialog(dialog);
			this.active = true;
		},

		close: function() {
			this.closeEventCount++;

			if(this.closeEventCount >= this.openEventCount) {
				this.active = false;

				this.resetEventsCount();
			}
		}
	}
}
</script>